import {
    SETTING,
    BASE_URL
} from '@/services/api'
import { post,putUpload,get } from "@/utils/request";

/**
 * 用户详情
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function userDetail() {
    return post(`${SETTING}/detail`)
}

/**
 * 修改用户信息
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function setMod(parmas) {
    return post(`${SETTING}/mod`,parmas)
}

/**
 * 修改密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function credential(parmas) {
    return post(`${SETTING}/credential`,parmas)
}

/**
 * 发送验证码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function setCode(parmas) {
    return post(`${SETTING}/code`,parmas)
}

/**
 * 手机号修改-安全验证
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function setCheck(parmas) {
    return post(`${SETTING}/check`,parmas)
}

/**
 * 手机号修改-确认新手机
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function modPhone(parmas) {
    return post(`${SETTING}/modPhone`,parmas)
}

/**
 * 新增数据
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function suggestSave(parmas) {
    return post(`${BASE_URL}/wd/biz/suggest/save`,parmas)
}

/**
 * 删除账号
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function setLogout() {
    return post(`${BASE_URL}/ai/set/logout`)
}

/**
 * 工单类附件上传上传
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function caseUploadFilesCase(param) {
    return putUpload(`${BASE_URL}/wd/biz/suggest/uploadFileOther`, param)
}

/**
 * 工单类附件下载
 * @returns {Promise<AxiosResponse<T>>}
 */
export function caseDownloadFile(param) {
    return `${BASE_URL}/wd/biz/suggest/downloadFile?fileId=${param.fileId}&fileName=${param.fileName}`
}

// 维盾智库-策略
export async function strategyList() {
    return get(`${BASE_URL}/wd/ai/helper/agent/strategy/list`)
}

// 维盾智库-默认智能体
export async function agentDefault() {
    return get(`${BASE_URL}/ext/wd/ai/helper/agent/default`)
}

// 维盾智库-智能体详情
export async function agentInfo(agentId) {
    return get(`${BASE_URL}/ext/wd/ai/helper/agent/info/${agentId}`)
}

// 是否ai开通业务
export async function openService() {
    return get(`${BASE_URL}/ai/home/openService`)
}